import React from 'react';
import styled from 'styled-components';

import { createCollecticon } from '../collecticon-creator';

export const CollecticonDownload2 = styled(
  createCollecticon((props) => (
    <svg {...props}>
      <title>{props.title || 'download 2 icon'}</title>
      <path d='M12.706,8.294l-1.416-1.416L9,9.172V0H7v9.172L4.706,6.878L3.291,8.294L8,13L12.706,8.294z M16,14H0v2h16V14z' />
    </svg>
  ))
)`
  /* icons must be styled-components */
`;
